import React from 'react';
import { Calculator, ArrowRight, LayoutGrid } from 'lucide-react';

const UtilityHome = ({ onSelectUtility }) => {
  const utilities = [
    {
      id: 'gpa-calculator',
      title: 'GPA Calculator',
      description: 'Precision academic tools for CGPA, Semester GPA, and Subject marks specifically for COMSATS university.',
      icon: Calculator,
      color: 'bg-indigo-50 text-indigo-600',
      borderColor: 'hover:border-indigo-200',
      badge: 'Academic'
    },
    // Future utilities can go here
  ];

  return (
    <div className="animate-in fade-in slide-in-from-bottom-4 duration-500">
      <div className="mb-8">
        <h2 className="text-2xl font-black text-slate-900 dark:text-white tracking-tight flex items-center gap-3">
          <LayoutGrid className="text-indigo-600" />
          Campus Utilities
        </h2>
        <p className="text-slate-500 dark:text-slate-400 font-medium">
          Powerful tools designed to enhance your academic journey.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {utilities.map((util) => (
          <div
            key={util.id}
            onClick={() => onSelectUtility(util.id)}
            className={`group bg-white dark:bg-[#0f1535] p-6 rounded-[2rem] border-2 border-transparent ${util.borderColor} shadow-sm hover:shadow-xl hover:shadow-indigo-500/5 transition-all duration-300 cursor-pointer relative overflow-hidden`}
          >
            <div className="flex items-start justify-between relative z-10">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-4">
                  <div className={`p-3 ${util.color} rounded-2xl group-hover:scale-110 transition-transform`}>
                    <util.icon size={24} />
                  </div>
                  <span className="px-3 py-1 bg-slate-100 dark:bg-white/5 text-slate-500 dark:text-slate-400 text-[10px] font-black uppercase tracking-widest rounded-full">
                    {util.badge}
                  </span>
                </div>
                
                <h4 className="text-xl font-black text-slate-900 dark:text-white tracking-tight mb-2 group-hover:text-indigo-600 dark:group-hover:text-indigo-400 transition-colors">
                  {util.title}
                </h4>
                <p className="text-slate-500 dark:text-slate-400 text-sm font-medium leading-relaxed max-w-[280px]">
                  {util.description}
                </p>
                
                <div className="mt-6 flex items-center gap-2 text-indigo-600 dark:text-indigo-400 font-black text-xs uppercase tracking-widest opacity-0 group-hover:opacity-100 transition-all">
                  Launch Utility
                  <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                </div>
              </div>
            </div>
          </div>
        ))}
        
        {/* Placeholder for coming soon */}
        <div className="bg-slate-50/50 dark:bg-white/5 p-6 rounded-[2rem] border-2 border-dashed border-slate-200 dark:border-indigo-500/20 flex flex-col items-center justify-center text-center py-12">
           <div className="w-12 h-12 rounded-full bg-slate-100 dark:bg-white/5 flex items-center justify-center text-slate-400 mb-4 text-2xl font-black">
              +
           </div>
           <h4 className="text-slate-400 font-bold">More coming soon</h4>
           <p className="text-slate-400 text-xs font-medium">Have an idea? Contact us!</p>
        </div>
      </div>
    </div>
  );
};

export default UtilityHome;
